import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13cb310d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "k-color-container" }

import { ref } from 'vue';
import { useMotions } from '@vueuse/motion';
import { getGameSetTransitions, gameSetLeave } from './transitions';
import { hapticsImpactLight } from 'src/util/device-util';
import chroma from 'chroma-js';
import { sample } from 'lodash';



export default /*#__PURE__*/_defineComponent({
  __name: 'single-color-picker',
  props: {
    colors: null
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
    colors: chroma.Color[]
}

_useCssVars(_ctx => ({
  "155e45ed": (_ctx.$props.colors[0].hex())
}))





const handleColorSelected = () => {
    hapticsImpactLight()
    emit('select', props.colors[0]);
}

const entered = ref(false);
const handleTransitionComplete = (index: number) => {
    if (entered.value === false){
        entered.value = true;
        emit('enter');
    }
}

const btnClass = sample([
    'k-single-color-btn--circle',
    'k-single-color-btn--square'
])!;

expose({
    leave: () => gameSetLeave(useMotions())
})

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _mergeProps({
      class: _unref(btnClass),
      onClick: handleColorSelected
    }, _unref(getGameSetTransitions)(0, { onComplete: handleTransitionComplete })), null, 16), [
      [_directive_motion, `btnMotion0`]
    ])
  ]))
}
}

})